import { render, staticRenderFns } from "./content-layout.vue?vue&type=template&id=666fb14c&"
import script from "./content-layout.vue?vue&type=script&lang=ts&"
export * from "./content-layout.vue?vue&type=script&lang=ts&"
import style0 from "./content-layout.vue?vue&type=style&index=0&id=666fb14c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports